module.exports = [
  {
    n: "Playgoy Carstein",
    a: 1,
    l: "https://www.youtube.com/@need59",
    lo: "https://yt3.googleusercontent.com/lca5FOlwsHGetxJCyPJPRejs0xb8zC74eq7QuAfG4sx2TvJY1kXF-5Qhik3SaZg-tkw__cRm=s160-c-k-c0x00ffffff-no-rj",
    c: 1,
  },
];
